function DashboardFooter({ children }: React.PropsWithChildren<{}>) {
  return <footer className="px-2 py-1 bg-gray-300">{children}</footer>;
}

export default DashboardFooter;
